import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExtensionUrlHandler = ( createDecorator('extensionUrlHandler'));
export { IExtensionUrlHandler };
